import ampInit from '@elastic/apm-rum';

import { Storage } from '@/enums/storage.enum';
import { config } from './config';

export const apm = process.env.VUE_APP_LOGS_SERVER
  ? ampInit({
      serviceName: config.logServiceName,
      serverUrl: config.logServerUrl,
      serviceVersion: config.serviceVersion
    })
  : undefined;

export function captureError(error: Error, metadata?: Labels) {
  if (!apm) {
    return;
  }
  if (metadata) {
    apm.addLabels(metadata);
  }
  apm.setUserContext({ id: localStorage.getItem(Storage.PROFILE_ID) as string });
  apm.captureError(error);
}
